import {
  GetDetailResponse,
  GetListResponse,
  Setting,
  UpdateSetting,
} from "@app/types";
import HttpService from "@core/services/http/http.service";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _SettingService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<Setting>>("/admin/api/v2/setting", {
      queryParams: { ...requestParams },
      signal,
    });
  }

  public update(settingId: number, updateSetting: UpdateSetting) {
    return HttpService.patch(`/admin/api/v2/setting/${settingId}`, {
      body: { ...updateSetting },
    });
  }

  public getSettingById(settingId: number) {
    return HttpService.get<GetDetailResponse<Setting>>(
      `/admin/api/v2/setting/${settingId}`
    );
  }
}

const SettingService = new _SettingService();

export default SettingService;
